import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VERBS = 'triviumVerbsProgress';
const isProgressKey = (k) => k.startsWith('learning_') || k === VERBS;
const read = (k) => { try { return JSON.parse(localStorage.getItem(k) || '{}'); } catch { return {}; } };
const auth = () => { const t = localStorage.getItem('token'); return t ? { Authorization: `Bearer ${t}` } : null; };

// Save one progress key (lesson completions or verb scores) to the signed-in account.
export const pushProgress = (key) => {
  const headers = auth();
  if (headers) axios.put(`${BACKEND_URL}/api/learning/progress`, { key, value: read(key) }, { headers }).catch(() => {});
};

const mergeVerbs = (a, b) => {
  const out = { ...a };
  Object.entries(b || {}).forEach(([lv, scores]) => {
    out[lv] = { ...(out[lv] || {}) };
    Object.entries(scores || {}).forEach(([s, v]) => { out[lv][s] = Math.max(out[lv][s] || 0, v || 0); });
  });
  return out;
};

// Combine account progress with this device, then save anything new back to the account.
export const syncProgress = async () => {
  const headers = auth();
  if (!headers) return;
  const { data } = await axios.get(`${BACKEND_URL}/api/learning/progress`, { headers });
  const server = data.data || {};
  const keys = new Set([...Object.keys(server), ...Object.keys(localStorage).filter(isProgressKey)]);
  keys.forEach((k) => {
    const local = read(k);
    const merged = k === VERBS ? mergeVerbs(local, server[k]) : { ...(server[k] || {}), ...local };
    localStorage.setItem(k, JSON.stringify(merged));
    if (JSON.stringify(merged) !== JSON.stringify(server[k] || {})) pushProgress(k);
  });
  window.dispatchEvent(new Event('bwgela-progress-synced'));
};
